export default "__VITE_ASSET__BbyQ8e8D__"